export class PrintFailedError extends Error {
  constructor(
    public httpError: any,
    public payloadSize: number
  ) {
    super();
  }
}
